import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AUCTIONEER_PROP_TYPE } from '../utils/props';
import {
    getAuctioneerUrl,
    getAuctioneerListUrl
} from '../utils/urls';

var AuctioneerExpertise = function(props) {
    var auctioneer = props.auctioneer;
    var truncateList = props.truncateList || false;
    var truncateLength = props.truncateLength || 2;
    var className = props.className;

    var expertise = auctioneer && auctioneer.expertise;

    if (!expertise || !expertise.length || !expertise.slice) {
        return null;
    }

    var originalLength = expertise.length;

    if (truncateList) {
        expertise = expertise.slice(0, truncateLength);
    }

    var elements = expertise.map(function(item) {
        return (
            <Link
                className="al-category-tag"
                to={getAuctioneerListUrl(1, item.id)}
                key={item.id}
            >
                {item.name}
            </Link>
        );
    });

    if (elements.length !== originalLength) {
        elements = elements.concat([
            <Link
                className="al-category-tag"
                to={getAuctioneerUrl(auctioneer.id)}
                key="more"
            >
                more →
            </Link>
        ]);
    }

    return (
        <div className={'al-expertise-tags ' + (className || '')}>
            {elements}
        </div>
    );
};

AuctioneerExpertise.propTypes = {
    truncateList: PropTypes.bool,
    truncateLength: PropTypes.number,
    className: PropTypes.string,
    auctioneer: AUCTIONEER_PROP_TYPE
};

export default AuctioneerExpertise;
